import HttpRequest from "@/plugins/http";

const request = new HttpRequest({
  baseURL: "/hotel/shopping/v1",
});

const axios = request.request();

/**
 * Availability Area 酒店信息
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function availabilityArea(params) {
  return axios.post("/availability/area", params);
}

/**
 * Availability property 房型信息
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function availabilityProperty(params) {
  return axios.post("/availability/property", params);
}

/**
 * BedType List
 * @export
 * @param {Object} params - { params: { BedTypeCode: "BT00" } }
 * @param {string} [params.BedTypeCode] -
 * @returns
 */
export async function bedtypeList(params) {
  return axios.get("/bedtype/list", params);
}
export async function bedtypedelete(params) {
  return axios.get("/bedtype/delete", params);
}

/**
 * BedType Save
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function bedtypeSave(params) {
  return axios.post("/bedtype/save", params);
}

/**
 * Destination - city list
 * @export
 * @param {Object} params -
 * @param {string} [params.Timestamp] -
 * @returns
 */
export async function cityconfigList(params) {
  return axios.get("/city/configList", params);
}

/**
 * Destination - city list
 * @export
 * @param {Object} params -
 * @param {string} [params.Timestamp] -
 * @returns
 */
export async function cityList(params) {
  return axios.get("/city/list", params);
}

/**
 * Destination - location list
 * @export
 * @param {Object} params -
 * @param {string} [params.Timestamp] -
 * @param {string} [params.CityCode] -
 * @returns
 */
export async function locationList(params) {
  return axios.get("/location/list", params);
}
/**HBE配置
 * locationlist
 * @export
 * @param {Object} params - 查看swagger
 * @returns
 */
export async function enableList(params) {
  return axios.get("/destination/enable", params, {});
}
export async function savelocationList(params) {
  return axios.post("/location/save", params, {});
}
export async function deletelocationList(params) {
  return axios.get("/location/delete", params, {});
}
export async function getcountryList(params) {
  return axios.get("/country/list", params, {});
}
export async function savecountryList(params) {
  return axios.post("/country/save", params, {});
}
export async function deletecountryList(params) {
  return axios.get("/country/delete", params, {});
}
export async function getprovinceList(params) {
  return axios.get("/province/list", params, {});
}
export async function saveprovinceList(params) {
  return axios.post("/province/save", params, {});
}
export async function deleteprovinceList(params) {
  return axios.get("/province/delete", params, {});
}
export async function savecityList(params) {
  return axios.post("/city/save", params, {});
}
export async function deletecityList(params) {
  return axios.get("/city/delete", params, {});
}

// 根据传入字段名称动态调用接口 params: { type: "countrymapping", paramsData: {} }
export async function fetchMapping(paramsData) {
  const axiosUrl = "/" + paramsData.type + "/fetch";
  return axios.get(axiosUrl, paramsData.paramsObj, {});
}
export async function saveMapping(paramsData) {
  const axiosUrl = "/" + paramsData.type + "/save";
  return axios.post(axiosUrl, paramsData.data, {});
}
export async function deleteMapping(paramsData) {
  const axiosUrl = "/" + paramsData.type + "/delete";
  return axios.get(axiosUrl, paramsData.paramsObj, {});
}

export async function buttonEnable(params) {
  return axios.get("/destination/enable", params);
}
/**
 * Hotel - Get multiple hotel information
 * @export
 * @param {Object} params -
 * @param {integer} [params.page] -
 * @param {integer} [params.per_page] -
 * @param {integer} [params.PosCode] -
 * @returns
 */
export async function getHotelList(params) {
  return axios.get("/hotel/list", params);
}

/**
 * Hotel - Get a hotel information
 * @export
 * @param {Object} params -
 * @param {string} [params.hotel_id] -
 * @param {string} [params.PosCode] -
 * @returns
 */
export async function getHotelDetail(params) {
  return axios.get("/hotel/detail", params);
}

/**
 * Hotel lookup
 * @export
 * @param {Object} params -
 * @param {string} [params.hotelName] - 酒店名称
 * @param {string} [params.StarRating] - 星级
 * @param {string} [params.ContactNumber] - 联系电话
 * @param {integer} [params.pageIndex] - 当前页面号
 * @param {integer} [params.pageSize] - 每页数量
 * @returns
 */
export async function getHotelLookup(params) {
  return axios.get("/hotel/lookup", params);
}

/**
 * Hotel Facility -
 * @export
 * @returns
 */
export async function facilities(params) {
  return axios.get("/hotelFacility/facilities", params);
}

/**
 * Hotel Facility - Location Save
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function facilitySave(params) {
  return axios.post("/hotelFacility/save", params);
}
export async function facilityDelete(params) {
  return axios.get("/hotelFacility/delete", params);
}

/**
 * RoomType - Get multiple room types
 * @export
 * @param {Object} params -
 * @param {integer} [params.page] -
 * @param {integer} [params.per_page] -
 * @param {string} [params.hotel_id] -
 * @returns
 */
export async function roomTypes(params) {
  return axios.get("/hotelroomType/roomtypes", params);
}

/**
 * RoomType - Get multiple room types
 * @export
 * @param {Object} params -
 * @param {integer} [params.page] -
 * @param {integer} [params.per_page] -
 * @param {string} [params.hotel_id] -
 * @param {string} [params.PosCode] -
 * @returns
 */
export async function roomTypeList(params) {
  return axios.get("/hotelroomType/list", params);
}
/**
 * RoomType - Get one room type
 * @export
 * @param {Object} params -
 * @param {String} [params.roomtype_id] -
 * @param {string} [params.hotel_id] -
 * @param {string} [params.PosCode] -
 * @returns
 */
export async function roomTypeDetail(params) {
  return axios.get("/hotelroomType/detail", params);
}

/**
 * 目的地搜索
 * @param {*} params
 * @returns
 */
export async function searchDestination(params) {
  return axios.get("/destination/list", params);
}


/**
 * sourceList List
 * @export
 * @returns
 */
 export async function sourceList(params) {
  return axios.get("/source/list", params);
}
/**
 * sourceList List
 * @export
 * @returns
 */
 export async function sourceSave(params) {
  return axios.post("/source/save", params);
}

/**
 * sourceList List
 * @export
 * @returns
 */
 export async function sourceDelete(params) {
  return axios.get("/source/delete", params);
}

/**
 * sourceList List
 * @export
 * @returns
 */
 export async function sourceStatus(params) {
  return axios.get("/source/status", params);
}

/**
 * groupList
 * @export
 * @returns
 */
 export async function groupList(params) {
  return axios.get("/group/list", params);
}
/**
 * groupSave
 * @export
 * @returns
 */
 export async function groupSave(params) {
  return axios.post("/group/save", params);
}

/**
 * groupDelete
 * @export
 * @returns
 */
 export async function groupDelete(params) {
  return axios.get("/group/delete", params);
}

/**
 * groupDelete
 * @export
 * @returns
 */
 export async function groupImport(params) {
  return axios.post("/group/import", params);
}

/**
 * groupDelete
 * @export
 * @returns
 */
 export async function sourceGroupList(params) {
  return axios.get("/group/getSourceGroup", params);
}

/**
 * groupDelete
 * @export
 * @returns
 */
 export async function deleteSourceGroup(params) {
  return axios.get("/group/DeleteSourceGroup", params);
}

/**
 * groupDelete
 * @export
 * @returns
 */
 export async function addSourceGroup(params) {
  return axios.get("/group/addSourceGroup", params);
}

/**
 * groupDelete
 * @export
 * @returns
 */
export async function getAnnouncementInfo(params) {
  return axios.get("/hotel/announcement", params);
}

/**
 * 获取搜索历史记录
 * @export
 * @returns
 */
export async function getKeywordRecords(params) {
  return axios.get("/keyword/records", params);
}


/**
 * 获取新酒店集团数据
 * @export
 * @param {Object} params
 * @returns
 */
 export async function getHotelgroupInfo(params) {
  return axios.get("/group/search", params);
}

/**
 * 获取hbe酒店集团数据
 * @export
 * @param {Object} params
 * @returns
 */
export async function hbeGroupList(params) {
  return axios.get("/hbegroup/list", params);
}

/**
 * 添加hbe酒店集团数据
 * @export
 * @param {Object} params
 * @returns
 */
export async function hbeGroupSave(params) {
  return axios.post("/hbegroup/save", params);
}

/**
 * 删除hbe酒店集团数据
 * @export
 * @param {Object} params
 * @returns
 */
export async function hbeGroupDelete(params) {
  return axios.get("/hbegroup/delete", params);
}

/**
 * 获取酒店集团映射列表信息
 * @export
 * @param {Object} params
 * @returns
 */
export async function hbeGetMapping(params) {
  return axios.get("/hbegroup/getMapping", params);
}

/**
 * 删除配置关系
 * @export
 * @param {Object} params
 * @returns
 */
export async function hbeDeleteMapping(params) {
  return axios.get("/hbegroup/deleteMapping", params);
}

/**
 * 添加配置关系
 * @export
 * @param {Object} params
 * @returns
 */
export async function hbeAddMapping(params) {
  return axios.get("/hbegroup/addMapping", params);
}

/**
 * 获取打分酒店数据
 * @export
 * @param {Object} params
 * @returns
 */
export async function hotelScoreList(params) {
  return axios.get("/hotelScore/search", params);
}

/**
 * 添加打分酒店数据
 * @export
 * @param {Object} params
 * @returns
 */
export async function hotelScoreSave(params) {
  return axios.post("/hotelScore/save", params);
}

/**
 * 删除打分酒店数据
 * @export
 * @param {Object} params
 * @returns
 */
export async function hotelScoreDelete(params) {
  return axios.get("/hotelScore/delete", params);
}

/**
 * 获取自定义差标
 * @export
 * @param {Object} params
 * @returns
 */
export async function getHotelTravelRule(params) {
  return axios.get("/hotel/getHotelTravelRule", params);
}

/**
 * Destination - city list
 * @export
 * @param {Object} params -
 * @param {string} [params.Timestamp] -
 * @returns
 */
export async function revoveRecentRecords(params) {
  return axios.get("/city/revoveRecentRecords", params);
}

/**
 * Destination - city list
 * @export
 * @param {Object} params -
 * @param {string} [params.Timestamp] -
 * @returns
 */
export async function hotelArea(params) {
  return axios.post("/hotel/area", params);
}

/**
 * Hotel - Get multiple hotel information
 * @export
 * @param {Object} params -
 * @param {integer} [params.page] -
 * @param {integer} [params.per_page] -
 * @param {integer} [params.PosCode] -
 * @returns
 */
export async function getHotelSaleable(params) {
  return axios.get("/hotel/saleable", params);
}

/**
 * Availability property 房型信息(返回被屏蔽原因)
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function availabilityroomtypes(params) {
  return axios.post("/availability/roomtypes", params);
}

/**
 * Availability - downloadExcel
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function roomTypeDownLoadExcel(params) {
  return axios.post("/availability/downloadExcel", params, {
    responseType: "blob",
  });
}

/**
 * Availability savePreDownload
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function savePreDownload(params) {
  return axios.post("/availability/savePreDownload", params);
}

/**
 * Hotel - Get multiple hotel information
 * @returns
 */
export async function getPreDownloadList(params) {
  return axios.get("/availability/preDownload", params);
}

/**
 * Hotel - Get multiple hotel information
 * @export
 * @param {Object} params -
 * @param {integer} [params.page] -
 * @param {integer} [params.per_page] -
 * @param {integer} [params.PosCode] -
 * @returns
 */
export async function downloadExcelForId(params) {
  return axios.get("/availability/downloadExcelForId", params);
}
/**
 * 获取积分列表
 * @export
 * @param {Object} params
 * @returns
 */
export async function getPointsList(params) {
  return axios.get("/hbegroup/PointsList", params);
}

/**
 * 删除积分
 * @export
 * @param {Object} params
 * @returns
 */
export async function PointsDelete(params) {
  return axios.post("/hbegroup/PointsDelete",params);
}

/**
 * 保存积分配置
 * @export
 * @param {Object} params
 * @returns
 */
export async function SaveHotelPoint(params) {
  return axios.post("/hbegroup/SaveHotelPointAsync",params);
}

/**
 * 导出
 * @export
 * @param {Object} params
 * @returns
 */
export async function PointsListExport(params) {
   return axios.post("/hbegroup/PointsListExport", params, {
    responseType: "blob",
  });
}

/**
 * groupDelete
 * @export
 * @returns
 */
 export async function HotelPointsImport(params) {
  return axios.post("/hbegroup/HotelPointsImport", params);
}

